

export default {
  locale: 'it',
  Pagination: {
    items_per_page: '/ pagina',
    jump_to: 'vai a',
    jump_to_confirm: 'Conferma',
    page: 'Pagina',
    prev_page: 'Pagina precedente',
    next_page: 'Pagina successiva',
    prev_5: 'Precedente 5 pagine',
    next_5: 'Prossime 5 pagine',
    prev_3: 'Precedente 3 pagine',
    next_3: 'Prossime 3 pagine',
    page_size: 'dimensioni della pagina'
  },
  DatePicker: {
    lang: {
      placeholder: 'Selezionare la data',
      yearPlaceholder: "Selezionare l'anno",
      quarterPlaceholder: 'Selezionare il trimestre',
      monthPlaceholder: 'Selezionare il mese',
      weekPlaceholder: 'Selezionare la settimana',
      rangePlaceholder: ["Data d'inizio", 'Data di fine'],
      rangeYearPlaceholder: ["Anno d'inizio", 'Anno di fine'],
      rangeMonthPlaceholder: ["Mese d'inizio ", 'Mese di fine'],
      rangeWeekPlaceholder: ["Settimana d'inizio", 'Settimana di fine'],
      locale: 'it_IT',
      today: 'Oggi',
      now: 'Adesso',
      backToToday: 'Torna ad oggi',
      ok: 'Ok',
      clear: 'Cancella',
      month: 'Mese',
      year: 'Anno',
      timeSelect: "Seleziona l'ora",
      dateSelect: 'Seleziona la data',
      weekSelect: 'Seleziona la settimana',
      monthSelect: 'Seleziona il mese',
      yearSelect: "Seleziona l'anno",
      decadeSelect: 'Seleziona il decennio',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Il mese scorso (PageUp)',
      nextMonth: 'Il prossimo mese (PageDown)',
      previousYear: "L'anno scorso (Control + sinistra)",
      nextYear: "L'anno prossimo (Control + destra)",
      previousDecade: 'Ultimo decennio',
      nextDecade: 'Prossimo decennio',
      previousCentury: 'Secolo precedente',
      nextCentury: 'Prossimo secolo'
    },
    timePickerLocale: {
      placeholder: "Selezionare l'orario",
      rangePlaceholder: ["Ora d'inizio", 'Ora di fine']
    }
  },
  TimePicker: {
    placeholder: "Selezionare l'orario",
    rangePlaceholder: ["Ora d'inizio", 'Ora di fine']
  },
  Calendar: {
    lang: {
      placeholder: 'Selezionare la data',
      yearPlaceholder: "Selezionare l'anno",
      quarterPlaceholder: 'Selezionare il trimestre',
      monthPlaceholder: 'Selezionare il mese',
      weekPlaceholder: 'Selezionare la settimana',
      rangePlaceholder: ["Data d'inizio", 'Data di fine'],
      rangeYearPlaceholder: ["Anno d'inizio", 'Anno di fine'],
      rangeMonthPlaceholder: ["Mese d'inizio ", 'Mese di fine'],
      rangeWeekPlaceholder: ["Settimana d'inizio", 'Settimana di fine'],
      locale: 'it_IT',
      today: 'Oggi',
      now: 'Adesso',
      backToToday: 'Torna ad oggi',
      ok: 'Ok',
      clear: 'Cancella',
      month: 'Mese',
      year: 'Anno',
      timeSelect: "Seleziona l'ora",
      weekSelect: 'Seleziona la settimana',
      dateSelect: 'Seleziona la data',
      monthSelect: 'Seleziona il mese',
      yearSelect: "Seleziona l'anno",
      decadeSelect: 'Seleziona il decennio',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Il mese scorso (PageUp)',
      nextMonth: 'Il prossimo mese (PageDown)',
      previousYear: "L'anno scorso (Control + sinistra)",
      nextYear: "L'anno prossimo (Control + destra)",
      previousDecade: 'Ultimo decennio',
      nextDecade: 'Prossimo decennio',
      previousCentury: 'Secolo precedente',
      nextCentury: 'Prossimo secolo'
    },
    timePickerLocale: {
      placeholder: "Selezionare l'orario",
      rangePlaceholder: ["Ora d'inizio", 'Ora di fine']
    }
  },
  global: {
    placeholder: 'Selezionare'
  },
  Table: {
    filterTitle: 'Menù Filtro',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    filterEmptyText: 'Nessun filtro',
    emptyText: 'Nessun dato',
    selectAll: 'Seleziona pagina corrente',
    selectInvert: 'Inverti selezione nella pagina corrente',
    selectionAll: 'Seleziona tutti i dati',
    sortTitle: 'Ordina',
    expand: 'Esapandi riga',
    collapse: 'Chiudi riga',
    triggerDesc: 'Clicca per ordinare in modo discendente',
    triggerAsc: 'Clicca per ordinare in modo ascendente',
    cancelSort: 'Clicca per eliminare i filtri',
    filterCheckall: 'Seleziona tutto',
    filterSearchPlaceholder: 'Cerca nei filtri',
    selectNone: 'Pulisci tutti i dati'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Annulla',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Annulla'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Cerca qui',
    itemUnit: 'elemento',
    itemsUnit: 'elementi',
    remove: 'Rimuovi',
    selectCurrent: 'Seleziona pagina corrente',
    removeCurrent: 'Rimuovi pagina corrente',
    selectAll: 'Selezione tutti i dati',
    removeAll: 'Rimuovi tutti i dati',
    selectInvert: 'Inverti selezione nella pagina corrente'
  },
  Upload: {
    uploading: 'Caricamento...',
    removeFile: 'Rimuovi il file',
    uploadError: 'Errore di caricamento',
    previewFile: 'Anteprima file',
    downloadFile: 'Download file'
  },
  Empty: {
    description: 'Nessun dato'
  },
  Icon: {
    icon: 'icona'
  },
  Text: {
    edit: 'modifica',
    copy: 'copia',
    copied: 'copia effettuata',
    expand: 'espandi'
  },
  PageHeader: {
    back: 'Indietro'
  },
  Image: {
    preview: 'Anteprima'
  }
};
